import { render, staticRenderFns } from "./ErrorLayout.vue?vue&type=template&id=23c955b0&scoped=true"
import script from "./ErrorLayout.vue?vue&type=script&lang=js"
export * from "./ErrorLayout.vue?vue&type=script&lang=js"
import style0 from "./ErrorLayout.vue?vue&type=style&index=0&id=23c955b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c955b0",
  null
  
)

export default component.exports